<template>
  <div class="animate__animated animate__fadeIn">
    <div class="row text-center mt-3">
        <h5>Por favor ingresa los siguientes documentos</h5>
    </div>
    <div class="row ">
        <div class="col-md-3">
          <label class="form-label">Movimiento</label>
          <select class="form-select form-select-sm">
              <option selected disabled value="0">Pago a proveedores</option>
          </select>
        </div>
        <div class="col-md-3">
          <label class="form-label">Tipo de trámite</label>
          <select class="form-select form-select-sm" v-model="tipoTramite" @change="changedocument">
              <option selected disabled value="0">--Selecciona</option>
              <option v-for="(tramite, i) in catalogoTramite" :key="i" :value="tramite.idCatTipoTramite">{{ tramite.NombreTipoTramite }}</option>
          </select>
        </div>
    </div>
    <div class="row mt-5 text-center">
      <div class="col">
        <h6 style="color: red;">Todos los campos rojos son obligatorios para el trámite.</h6>
      </div>
    </div>
    <!-- <hr class="mt-3"> -->
    <div class="col-md-12 p-2">
      <table class="table">
        <thead>
          <tr>
            <th scope="col">Documento</th>
            <th scope="col" >Cargar Documento</th>
            <th scope="col" style="width: 250px;">Acción</th>
            <th scope="col"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(documento) in listDocuments" :key="documento.idField" style="width: 20px;">
            <td :style="documento.obligatorioField == 1 ? 'color: red;' : ''" scope="row">{{documento.nombreRequisitoField}}</td>
            <td class="text-center">
              <div class="input-group input-group-sm mb-3">
                <input type="file" class="file-select" accept=".pdf, .xml" @change="getDocument($event, documento.idField)">
              </div>
            </td>
            <td>
              <button class="btn btn-success mr-4" type="submit" style="border-radius: 15px;" :disabled="documento.documentoCargado" @click="uploadDocument(documento.idField, documento.obligatorioField,)">
                <i class="fas fa-search mr-2"></i>Cargar
              </button>
              <button class="btn btn-danger " type="submit" style="border-radius: 15px;" @click="deleteDocument(documento.idField)">
                <i class="fas fa-search mr-2"></i>Eliminar
              </button>
            </td>
            <td class="text-center">
              <div v-if="documento && documento.documento">
                <i class="far fa-file fa-2x" style="color: #74C0FC;"></i>
                <p>{{documento.documento.name}}</p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    getDocument: Function,
    uploadDocument: Function,
    deleteDocument: Function,
    catalogoDocumentosRequisitos: Function,
    listDocuments: Array,
    // Documentos: Array,
    catalogoTramite: Array,
    // tipoTramite: String,
  },
  data() {
    return {
      tipoTramite: '',
      // condicional: 'documento.documento =! true'
    }
  },
  methods:{
    changedocument(){
      this.catalogoDocumentosRequisitos(this.tipoTramite)
      console.log(this.tipoTramite);
    }
  }
}
</script>

<style scoped>
.file-select {
    position: relative;
    display: inline-block;
    width: 330px;
    height: 30px;
    margin-right: 20px;
    cursor: pointer;
    /* Añade un borde alrededor del elemento */
    border: 1px solid #cccccca6;
    border-radius: 5px;

}

.file-select::before {
    background-color: #f1f1f1;
    color: rgba(121, 120, 120, 0.548);
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: small;
    content: "Seleccionar archivo";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
}
.btn-primary{
    background-color: #1e536b !important;
    border-color: #1e536b !important;
}
p{
  margin-bottom: 0rem !important;
}
</style>